module.exports = __webpack_public_path__ + "img/service.85e13405.jpg";